import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on TIME LOGS
  fetchTimeLogs: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchTimeLogs';

    commit(`${mutationPrefix}Pending`);

    return api.fetchTimeLogs(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on TIME LOGS
  fetchRunningTimeLog: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchRunningTimeLog';

    commit(`${mutationPrefix}Pending`);

    return api.fetchRunningTimeLog(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on TIME LOGS
  fetchAllRunningTimeLog: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchAllRunningTimeLog';

    commit(`${mutationPrefix}Pending`);

    return api.fetchAllRunningTimeLog(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on TIME LOGS
  createTimeLog: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createTimeLog';

    commit(`${mutationPrefix}Pending`);

    return api.createTimeLog(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on TIME LOGS
  updateTimeLog: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateTimeLog';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateTimeLog(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses CUSTOM mutations on TIME LOGS
  startTimer: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'startTimer';

    commit(`${mutationPrefix}Pending`);

    return api.startTimer(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CUSTOM mutations on TIME LOGS
  stopTimer: (context, data = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'stopTimer';

    commit(`${mutationPrefix}Pending`);

    return api.stopTimer(data)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on TIME LOGS
  deleteTimeLog: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deleteTimeLog';

    commit(`${mutationPrefix}Pending`, id);

    return api.deleteTimeLog(id)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, response);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  openFormModal: ({ commit }, payload = null) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },

  openDetailsModal: ({ commit }, payload = null) => {
    commit('openDetailsModal', payload);
  },

  closeDetailsModal: ({ commit }) => {
    commit('closeDetailsModal');
  },

  openManualModal: ({ commit }, payload = null) => {
    commit('openManualModal', payload);
  },

  closeManualModal: ({ commit }) => {
    commit('closeManualModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/actions.js